import * as Sentry from "@sentry/react";
import { useState } from "react";

import axios from "axios";

import { GEO_MAP_SERVICE_ADDRESS } from "../../../constants/app.constants";
import { MapDataKind } from "../GeoMapDataTable/GeoMapDataTableWidget.types";

const useGeoMapExport = () => {
  const [isExporting, setIsExporting] = useState(false);

  const exportCsv = async (layerIds: number[], kind: MapDataKind) => {
    if (layerIds.length === 0) return;
    setIsExporting(true);
    try {
      const primaryId = layerIds[0];
      const params: Record<string, string | number> = { kind };
      if (layerIds.length > 1) {
        params.layer_ids = layerIds.join(",");
      }
      const response = await axios.get(
        `${GEO_MAP_SERVICE_ADDRESS}/map-layer/${primaryId}/data/export`,
        { params, responseType: "blob" }
      );
      const disposition = response.headers["content-disposition"] ?? "";
      const filenameMatch = disposition.match(/filename="?([^"\s;]+)"?/);
      const filename = filenameMatch?.[1] ?? `map-layer-${primaryId}-data.csv`;
      const url = URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      Sentry.withScope((scope) => {
        scope.setContext("exportCsv", { layerIds, kind });
        scope.setLevel("error");
        Sentry.captureException(error);
      });
    } finally {
      setIsExporting(false);
    }
  };

  return { exportCsv, isExporting };
};

export default useGeoMapExport;
